import { v4 as uuid } from "uuid"

import { ButtonBlockEditor } from "../Blocks/ButtonBlockEditor"
import { DividerBlockEditor } from "../Blocks/DividerBlockEditor"
import { HeroBlockEditor } from "../Blocks/HeroBlockEditor"
import { RichTextBlockEditor } from "../Blocks/RichTextBlockEditor"
import { TermsBlockEditor } from "../Blocks/TermsBlockEditor"
import { ButtonBlock, DividerBlock, HeroBlock, PromotionBlock, PromotionBlockType, RichTextBlock, TermsBlock } from "../types/types"

export type BlockEditorProps = {
  block: PromotionBlock
  onChange: (patch: Partial<PromotionBlock>) => void
}

type BlockDefinition = {
  type: PromotionBlockType
  label: string
  showInToolbar: boolean // should this appear as a button in toolbar
  create: () => PromotionBlock // default factory
  Editor: (props: BlockEditorProps) => JSX.Element
}

// Central registry for all block types
export const BLOCK_DEFINITIONS: Record<PromotionBlockType, BlockDefinition> = {
  hero: {
    type: "hero",
    label: "Hero",
    showInToolbar: true,
    create: (): HeroBlock => ({
      id: uuid(),
      type: "hero",
      props: {
        headline: "",
        subheadline: "",
        backgroundImage: ""
      }
    }),
    Editor: ({ block, onChange }) => <HeroBlockEditor block={block as HeroBlock} onChange={onChange} />
  },

  richText: {
    type: "richText",
    label: "Rich Text",
    showInToolbar: true,
    create: (): RichTextBlock => ({
      id: uuid(),
      type: "richText",
      props: {
        html: ""
      }
    }),
    Editor: ({ block, onChange }) => <RichTextBlockEditor block={block as RichTextBlock} onChange={onChange} />
  },

  terms: {
    type: "terms",
    label: "Terms & Conditions",
    showInToolbar: true,
    create: (): TermsBlock => ({
      id: uuid(),
      type: "terms",
      props: {
        title: "Terms & Conditions",
        html: "",
        collapsible: true,
        initiallyOpen: false
      }
    }),
    Editor: ({ block, onChange }) => <TermsBlockEditor block={block as TermsBlock} onChange={onChange} />
  },

  button: {
    type: "button",
    label: "Button",
    showInToolbar: true,
    create: (): ButtonBlock => ({
      id: uuid(),
      type: "button",
      props: {
        label: "",
        variant: "primary",
        actionType: "link",
        href: "https://example.com"
      }
    }),
    Editor: ({ block, onChange }) => <ButtonBlockEditor block={block as ButtonBlock} onChange={onChange} />
  },

  divider: {
    type: "divider",
    label: "Divider",
    showInToolbar: true,
    create: (): DividerBlock => ({
      id: uuid(),
      type: "divider",
      props: {
        height: 1,
        color: "rgba(255,255,255,0.12)",
        margin: 24,
        variant: "solid"
      }
    }),
    Editor: ({ block, onChange }) => <DividerBlockEditor block={block as DividerBlock} onChange={onChange} />
  }
}

export const TOOLBAR_BLOCKS = Object.values(BLOCK_DEFINITIONS).filter((def) => def.showInToolbar)
